import { MyExecutorsFiltersFormValues } from './types';

export const initialMyExecutorsFormFilters: MyExecutorsFiltersFormValues = {
  fullName: '',
  tin: '',
  ftsStatusName: [],
};

export const FULL_NAME_REGEXP = /^[А-Яа-я'\- ]+$/u;
